import { render, staticRenderFns } from "./PriceComparison.vue?vue&type=template&id=47849cf2&"
import script from "./PriceComparison.vue?vue&type=script&lang=js&"
export * from "./PriceComparison.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports